import React from 'react';
import { Image as RNImage } from 'react-native';

import { useImageSizeCalculator } from '../hooks/useImageSizeCalculator';
import { type ImageProps } from '../Image.types';

export const BaseImage = (props: ImageProps) => {
  const { source, ...rest } = props;
  const modifiedSource = useImageSizeCalculator(source);

  return (
    <RNImage
      source={modifiedSource}
      accessibilityIgnoresInvertColors
      {...rest}
    />
  );
};
